// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2Ow_c","bigColWidth":"Table_bigColWidth__1ItQ8","biggerColWidth":"Table_biggerColWidth__3lSXu","row":"Table_row__W0ozG","col":"Table_col__2nbgT"};